"use strict";

var _defineProperty = require("/Users/topedaramola/Documents/Client Work/UtterFun/utter/node_modules/@babel/runtime/helpers/defineProperty.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var inline_style_prefixer_1 = require("inline-style-prefixer");

var decamelize_1 = __importDefault(require("./utils/decamelize"));

var prefixRegex = /^(Webkit|ms|Moz|O)/;

function prefixer(property, value) {
  var rules = inline_style_prefixer_1.prefix(_defineProperty({}, property, value));
  var rulesArray = [];
  var propertyNames = Object.keys(rules);

  for (var i = 0; i < propertyNames.length; i++) {
    var propertyName = propertyNames[i];
    var prefixedProp = propertyName.match(prefixRegex) ? "-".concat(propertyName) : propertyName;
    var prop = decamelize_1.default(prefixedProp);
    var values = rules[propertyName];

    if (Array.isArray(values)) {
      for (var j = 0; j < values.length; j++) {
        rulesArray.push({
          property: prop,
          value: values[j]
        });
      }
    } else {
      rulesArray.push({
        property: prop,
        value: values
      });
    }
  }

  return rulesArray;
}

exports.default = prefixer;